import { CircleAlert, CircleCheck } from 'lucide-react';

export type ErrorStateIconProps = {
  isValid: boolean;
};

export function ErrorStateIcon({ isValid }: ErrorStateIconProps) {
  if (isValid) {
    return (
      <CircleCheck className='flex items-center justify-center ml-2 fill-lime-500 text-white' />
    );
  }

  return (
    <CircleAlert className='flex items-center justify-center ml-2 fill-rose-500 text-white' />
  );
}
